module.exports = __webpack_public_path__ + "media/images/lb/511-09e0c4ca2d84e8f98ac35d553e2b68d6.svg";